import Briza1 from "./B7x12 (1).webp";
import Briza2 from "./B7x12 (2).webp";
import Briza3 from "./B7x12 (3).webp";
import Briza4 from "./B7x12 (4).webp";
import Briza5 from "./B7x12 (5).webp";
import Briza6 from "./B7x12 (6).webp";
import Briza7 from "./B7x12 (7).webp";
import Briza8 from "./B7x12 (8).webp";
import Briza9 from "./B7x12 (9).webp";
import Briza10 from "./Briza 7x12.jpg";
const Briza7images = [
  Briza10,
  Briza1,
  Briza2,
  Briza3,
  Briza4,
  Briza5,
  Briza6,
  Briza7,
  Briza8,
  Briza9,
];

export default Briza7images;
